import {RouteConfig} from 'vue-router';
import OfficialHomeView from '@/views/official/home/home.vue';
import OfficialView from '@/views/official/Main.vue';
import CourseCatalogView from '@/views/official/course/course-catalog.vue';
import CourseDetailView from '@/views/official/course/course-detail.vue';

export enum CourseRouterPath {
  OFFICIAL_COURSE_CATALOG_VIEW = 'course-catalog',
  OFFICIAL_COURSE_DETAIL_VIEW = 'course-detail'
}

export const OfficialRoutes: Array<RouteConfig | any> = [
  {
    path: '/index',
    component: OfficialView,
    children: [
      {path: 'home', component: OfficialHomeView},
      {
        path: '/course/course-catalog/:id',
        component: CourseCatalogView,
        name: CourseRouterPath.OFFICIAL_COURSE_CATALOG_VIEW
      },
      {
        path: '/course/course-catalog/:id/course-detail/:courseId',
        component: CourseDetailView,
        name: CourseRouterPath.OFFICIAL_COURSE_DETAIL_VIEW
      }
    ],
  },
];
